import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render({ completed, next_position, position, card_index, house }) {
        return (
            <spread-card
                onmousedown={this.pick}
                className={!completed && next_position === card_index ? 'next' : ''}
                house={house}
                orientation={position.orientation}
            >
                {this.renderTitle()}
                {this.renderSpreadCardContent()}
            </spread-card>
        );
    }

    renderTitle = () => {
        //no titles on view 1
        if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.view && this.props.view == 'view-1') {
            return null;
        }

        if (this.props.position.title && !this.props.upc.match(/-1-card/)) {
            return (
                <h3 className='position-name'>{this.props.position.title.replace(/\/.*/, '')}</h3>
            );
        }

        return null;
    }

    renderSpreadCardContent = () => {
        const { card, upc, deck, product, view, card_index } = this.props;

        if (card) {
            if (upc == 'yes-or-no-tarot-redux') {
                //Show the Wheel of Fortune card (pre-selected)
                if (view == 'view-1' && card_index == 0) {
                    return (
                        <img alt={card.name} src={card.images.full} />
                    );
                }

                //Show the back for all other cards
                return [
                    <img
                        alt='card back'
                        src={`https://gfx.tarot.com/images/site/tarot/${upc}/card-back.svg`}
                    />,
                    <p className='card-name' />,
                ];
            }

            return [
                <img alt={card.name} src={card.images.full} />,
                upc.match(/-1-card/) && product.submitted ?
                    <small className='has-text-color-black'>
                        <a href={`/tarot/decks/${ deck.slug }`}>{deck.name}</a> deck {deck.deck_vendor_copyright}
                    </small>
                    : <p className='card-name'>{card.name}</p>,

            ];
        }

        return [
            <div className='outline' />,
            <p className='card-name' />,
        ];
    }

    pick = () => {
        if (this.props.spread && !this.props.report) {
            const available_ids = this.props.spread.filter(cardId => cardId != 'picked');
            const card_index = Math.floor(Math.random() * available_ids.length);
            const card_id = available_ids[card_index];

            if (this.props.completed) {
                if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.view == 'view-1') {
                    this.props.trackEvent([
                        'Tarot Readings',
                        'Click',
                        'Shuffle Cards',
                        `Readings-${this.props.upc}:ShuffleCards`,
                    ]);

                    document.querySelector('button[data-action="Click-Shuffle-Cards-Button"]').click();
                    return;
                }

                this.props.trackEvent([
                    'Tarot Readings',
                    'Click',
                    'Reveal Meaning',
                    `Readings_${this.props.upc}:RevealMeaning`,
                ]);

                this.props.trackCheckoutEvent({
                    event: 'add_to_cart',
                    upc: this.props.upc,
                    name: this.props.product.teeup.display_name,
                });

                this.props.tarotFetch();
            } else {
                this.props.tarotPicked(card_id);
                this.props.deckSpread(card_id);
            }
        }
    }
}

const mapStateToProps = (state, props) => ({
    card: state.deck && state.deck.cards && state.deck.cards[props.card_id],
    completed: state.product && state.product.teeup && state.product.teeup.fields
        && state.product.teeup.fields[2] && state.product.teeup.fields[2].positions
        && state.product.teeup.fields[2].positions.length > 0
        && state['tarot-reading'] && state['tarot-reading'].cards
        && state['tarot-reading'].cards.length === state.product.teeup.fields[2].positions.length,
    deck: state.deck,
    spread: state.spread,
    next_position: state['tarot-reading'].cards.length,
    upc: state.product && state.product.teeup.code,
    product: state.product,
    report: state.report,
});

const mapDispatchToProps = (dispatch) => ({
    trackCheckoutEvent: (action) => dispatch({ type: 'ga:checkout_event', payload: action }),
    trackEvent: (action) => dispatch({ type: 'ga:event', payload: action }),
    tarotFetch: () => dispatch({ type: 'tarot-reading:fetch' }),
    deckSpread: (card_id) => dispatch({ type: 'deck:spread', payload: card_id }),
    tarotPicked: (card_id) => dispatch({ type: 'tarot-reading:picked', payload: { card: card_id, source: 'Layout' }}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
